import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-drones',
  templateUrl: './drones.component.html',
  styleUrls: ['./drones.component.sass']
})
export class DronesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
